import script from "./autenticado.vue?vue&type=script&setup=true&lang=js"
export * from "./autenticado.vue?vue&type=script&setup=true&lang=js"

import "../assets/css/styles-sider.css?vue&type=style&index=0&lang=css&external"
import "../assets/css/autenticado-layout.css?vue&type=style&index=1&lang=css&external"
import "./autenticado.vue?vue&type=style&index=2&id=14b51016&lang=scss"

const __exports__ = script;

export default __exports__